import { Message, Loading } from 'element-ui';
import Axios from "@/api/exportFileRequest";
// 使用导出时添加签名
export const mixin_export = async (url, method = 'get', param) => {
    if (method === 'get') {
        let paramsStr = ``;
        let datas = {};
        if (param) {
            Object.keys(param).forEach(key => {
                if (param[key] != null) {
                    paramsStr += `&${key}=${param[key]}`;
                }
                datas[key] = param[key];
            });
            paramsStr = paramsStr.slice(1);
        }
        let loadingInstance = Loading.service({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        Axios.getExportFile(`${window.location.origin}${url}?${paramsStr}`).then((res) => {
            loadingInstance.close();
            if (Number(res.headers.status) === 200) {
                try {
                    let objectUrl = window.URL.createObjectURL(res.data);
                    let link = document.createElement('a');
                    link.style.display = 'none';
                    link.href = objectUrl;
                    let fileName = decodeURIComponent(res.headers.filename);
                    // 带拓展名
                    // link.setAttribute('download', `${filename}.xlsx`);
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                }
                catch (err) {
                    alert(`[File-Export]: ${err}`);
                }
            }
            else {
                Message.error(decodeURIComponent(res.headers.msg));
            }
        });
    }
    else {
        let loadingInstance = Loading.service({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        Axios.postExportFile(`${window.location.origin}${url}`, param).then((res) => {
            loadingInstance.close();
            if (Number(res.headers.status) === 200) {
                try {
                    let objectUrl = window.URL.createObjectURL(res.data);
                    let link = document.createElement('a');
                    link.style.display = 'none';
                    link.href = objectUrl;
                    let fileName = decodeURIComponent(res.headers.filename);
                    // 带拓展名
                    // link.setAttribute('download', `${filename}.xlsx`);
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                }
                catch (err) {
                    alert(`[File-Export]: ${err}`);
                }
            }
            else {
                Message.error(decodeURIComponent(res.headers.msg));
            }
        }).catch((err) => {
            loadingInstance.close();
            Message.error('导出条件有误，请检查导出条件');
        });
    }
};
